<script lang="ts">
	import { DataHandlerDevice, type Device } from "luxedo-data"
	import { onMount } from "svelte"
	import { ScheduleController } from "../ScheduleController"
	import { DeviceSelector } from "luxedo-comps"

	interface Props {
		isValid?: boolean
	}

	let { isValid = $bindable() }: Props = $props()
	isValid = false

	let allDevices: Array<Device> = $state([])
	let selected: Device = $state(undefined)

	ScheduleController.EventEditor.subscribe((ctx) => {
		selected = ctx?.selectedDevice ?? undefined
		isValid = !!ctx?.selectedDevice
	})

	onMount(() => {
		allDevices = DataHandlerDevice.getMany()
	})
</script>

{#each allDevices as device}
	<DeviceSelector
		deviceId={device.id}
		isSelected={selected && selected.id === device.id}
		onSelect={ScheduleController.EventEditor.selectDevice}
	/>
{/each}

<style>
</style>
